import { z } from 'zod';

/**
 * Roster of org-level contact roles surfaced in the Pipeline assignment picker
 * + the workflow action recipient picker. UI labels live in CONTACT_TYPE_LABELS.
 */
export const ContactTypeSchema = z.enum([
  'processor',
  'loan_officer', // displayed as "MLO"
  'assistant', // displayed as "LOA" (Loan Officer Assistant)
  'title', // displayed as "Title company"
  'borrower',
  'underwriter',
  'realtor',
  'attorney',
  'other',
]);
export type ContactType = z.infer<typeof ContactTypeSchema>;

export const CONTACT_TYPE_LABELS: Record<ContactType, string> = {
  loan_officer: 'MLO',
  assistant: 'LOA',
  processor: 'Processor',
  title: 'Title company',
  borrower: 'Borrower',
  underwriter: 'Underwriter',
  realtor: 'Realtor',
  attorney: 'Attorney',
  other: 'Other',
};

export const ContactSchema = z.object({
  id: z.string(),
  organizationId: z.string(),
  name: z.string().min(1).max(120),
  email: z.string().email().nullable().optional(),
  phone: z.string().nullable().optional(),
  whatsappPhone: z.string().nullable().optional(),
  contactType: ContactTypeSchema,
  active: z.boolean(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});
export type Contact = z.infer<typeof ContactSchema>;

export const CreateContactInputSchema = ContactSchema.pick({
  name: true,
  email: true,
  phone: true,
  whatsappPhone: true,
  contactType: true,
}).extend({
  active: z.boolean().default(true),
});
export type CreateContactInput = z.infer<typeof CreateContactInputSchema>;

/** PATCH body — every field optional; server merges into the existing row. */
export const UpdateContactInputSchema = z.object({
  name: z.string().min(1).max(120).optional(),
  email: z.string().email().nullable().optional(),
  phone: z.string().nullable().optional(),
  whatsappPhone: z.string().nullable().optional(),
  contactType: ContactTypeSchema.optional(),
  active: z.boolean().optional(),
});
export type UpdateContactInput = z.infer<typeof UpdateContactInputSchema>;
